module.exports = __webpack_public_path__ + "static/media/chicken.f9476fee.png";